// Mock notification services

export interface EmailNotification {
  to: string[];
  subject: string;
  body: string;
  attachments?: string[];
}

export interface WhatsAppNotification {
  to: string[];
  message: string;
}

export interface SMSNotification {
  to: string[];
  message: string;
}

export const mockEmailService = {
  send: async (notification: EmailNotification): Promise<boolean> => {
    console.log('📧 [MOCK EMAIL]', notification);
    await new Promise((resolve) => setTimeout(resolve, 500));
    return true;
  },
};

export const mockWhatsAppService = {
  send: async (notification: WhatsAppNotification): Promise<boolean> => {
    console.log('📱 [MOCK WHATSAPP]', notification);
    await new Promise((resolve) => setTimeout(resolve, 500));
    return true;
  },
};

export const mockSMSService = {
  send: async (notification: SMSNotification): Promise<boolean> => {
    console.log('💬 [MOCK SMS]', notification);
    await new Promise((resolve) => setTimeout(resolve, 500));
    return true;
  },
};

export const sendAllNotifications = async (
  emails: string[],
  whatsapp: string[],
  sms: string[],
  subject: string,
  message: string
): Promise<void> => {
  const promises: Promise<boolean>[] = [];

  if (emails.length > 0) {
    promises.push(mockEmailService.send({ to: emails, subject, body: message }));
  }

  if (whatsapp.length > 0) {
    promises.push(mockWhatsAppService.send({ to: whatsapp, message }));
  }

  if (sms.length > 0) {
    promises.push(mockSMSService.send({ to: sms, message }));
  }

  await Promise.all(promises);
};







